import { Injectable, signal } from '@angular/core';

interface UserListHeaderHandlers {
  addUser: () => void;
  export: () => void;
  refresh: () => void;
}

@Injectable({ providedIn: 'root' })
export class UserListHeaderService {
  private readonly activeState = signal(false);
  private connection: symbol | null = null;
  private handlers: UserListHeaderHandlers | null = null;

  readonly active = this.activeState.asReadonly();

  connect(handlers: UserListHeaderHandlers): symbol {
    const connection = Symbol('user-list-header');
    this.connection = connection;
    this.handlers = handlers;
    this.activeState.set(true);
    return connection;
  }

  disconnect(connection: symbol): void {
    if (connection !== this.connection) return;
    this.connection = null;
    this.handlers = null;
    this.activeState.set(false);
  }

  addUser(): void {
    this.handlers?.addUser();
  }

  export(): void {
    this.handlers?.export();
  }

  refresh(): void {
    this.handlers?.refresh();
  }
}
